/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Zone_EasyInputs */

const en_ui_zone_easy = /** @type {(inputs: Ui_Zone_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Easy`)
};

const de_ui_zone_easy = /** @type {(inputs: Ui_Zone_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locker`)
};

/**
* | output |
* | --- |
* | "Easy" |
*
* @param {Ui_Zone_EasyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_zone_easy = /** @type {((inputs?: Ui_Zone_EasyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Zone_EasyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_zone_easy(inputs)
	return de_ui_zone_easy(inputs)
});